<ng-container *ngIf="costTypeState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ (data.id ? 'app.dialog.cost-type-group.title-update.header' : 'app.dialog.cost-type-group.title-create.header') | translate}}
    </h1>
    <div mat-dialog-content>
        <mat-generic-input
            [fields]="state.costTypeGroupDialogFields"
            [(inputFormGroup)]="formGroup"
            [initialValue]="data">
        </mat-generic-input>
    </div>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
        <button [disabled]="!dialogFieldsValid" mat-flat-button color="primary" (click)="save()">{{ "app.button.save.label" | translate }}</button>
    </div>
</ng-container>
